export enum ProductTemplates {
    CNG_DEFAULT = 'cngDefault',
    CNG_FCC_IMAGE = 'cngFccImage',
    CNG_FCC_2_IMAGES = 'cngFcc2Images',
    CNG_FORM = 'cngForm',
    CNG_GRID = 'cngGrid',
    GRID = 'grid',
    FILTER = 'filter',
    CUSTOM_TEMPLATE = 'customTemplate',
    CNG_SCREEN = 'cngScreen',
}
